import React from 'react';
import Image from 'next/image';
import { useRouter } from 'next/router';

import { globalConst, onTrackYandexGoal } from 'modules/global';
import { topicTestsConst } from 'modules/mavzuli-test';

import { LinkWrapper } from 'components';

import { InfoSection } from './info-section';
import { ProgressSection } from './progress-section';

export const LeftSide = () => {
  const { query } = useRouter();
  const banner = topicTestsConst?.subjectBannerMap[query?.subject as string];

  return (
    <div className="hidden space-y-3 sm:block lg:sticky lg:top-4 lg:self-start">
      <InfoSection />
      <ProgressSection />

      {banner && (
        <div className="h-70 relative hidden w-full lg:block">
          <LinkWrapper
            target="_blank"
            isNotLink={banner?.isNotLink}
            onClick={() => onTrackYandexGoal(globalConst.yandexGoalKeys.rising_zone)}
            href={banner?.targetUrl || 'https://akam.uz'}
          >
            <Image
              src={banner?.desktop}
              alt="schools banner"
              title="Maktablarning banneri (reklama)"
              fill
              className="rounded-xl"
            />
          </LinkWrapper>
        </div>
      )}
    </div>
  );
};
